import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { MerchantForm } from '@/components/features/merchants/merchant-form';
import { useCreateMerchant } from '@/hooks/use-merchants';
import type { CreateMerchantParams, UpdateMerchantParams } from '@/types/merchant';

export function MerchantCreatePage() {
  const { t } = useTranslation('merchants');
  const navigate = useNavigate();
  const createMutation = useCreateMerchant();

  const handleSubmit = async (data: CreateMerchantParams | UpdateMerchantParams) => {
    try {
      const merchant = await createMutation.mutateAsync(data as CreateMerchantParams);
      toast.success(t('actions.createSuccess'));
      navigate(`/merchants/${merchant.merchantId}`);
    } catch {
      // Error is available via createMutation.error — form handles display
    }
  };

  return (
    <div>
      <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{t('form.createTitle')}</h1>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate('/merchants')}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('detail.back')}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('form.createTitle')}</CardTitle>
        </CardHeader>
        <CardContent>
          <MerchantForm
            mode="create"
            onSubmit={handleSubmit}
            onCancel={() => navigate('/merchants')}
            isLoading={createMutation.isPending}
            error={createMutation.error}
          />
        </CardContent>
      </Card>
    </div>
  );
}
